import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private http: HttpClient,
  ) { }


  report(slug: string, params: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/report/${slug}`, params);
  }



}
